import {MasterCategory, SubCategory} from "../index";

export const isMasterCategory = (category: MasterCategory|SubCategory): boolean => {
    return !({}).hasOwnProperty.call(category, 'masterCategoryId');
}